import React from 'react';

class ErrorBoundary extends React.Component<{ children: React.ReactNode }, { hasError: boolean }> {
	constructor(props: any) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError() {
		return { hasError: true };
	}

	componentDidCatch(error: Error) {
		console.error('Caught by ErrorBoundary:', error);
		window.location.reload();
	}

	render() {
		return this.props.children;
	}
}

export default ErrorBoundary;
